// import Dashboard from "../pages/Dashboard";
import PageNotFound from "../components/PageNotFound";
import Dashboard from "../pages/dashboard/Dashboard";

export default [
    {
        path: "/dashboard",
        component: Dashboard,
        isProtected: true,
      },
      {
        path: "*",
        component: PageNotFound,
        isProtected: true,
      },
]